import { ShieldCheck, Circle, Waves, HelpCircle, AlertCircle, AlertTriangle } from "lucide-react";

const CONF = {
  CONFIRMED: { icon: ShieldCheck, label: "Verified", cls: "bg-emerald-50 text-emerald-800 border-emerald-300" },
  HOMEOWNER_REPORTED: { icon: Circle, label: "Self-reported", cls: "bg-blue-50 text-blue-800 border-blue-300" },
  ESTIMATED: { icon: Waves, label: "Estimated", cls: "bg-amber-50 text-amber-800 border-amber-300" },
  UNKNOWN: { icon: HelpCircle, label: "Unknown", cls: "bg-slate-100 text-slate-700 border-slate-300" },
  NEEDS_REVIEW: { icon: AlertCircle, label: "Needs verification", cls: "bg-purple-50 text-purple-800 border-purple-300" },
  CONFLICTING: { icon: AlertTriangle, label: "Conflict detected", cls: "bg-red-50 text-red-800 border-red-300" },
};

export const ConfidenceBadge = ({ status, testId }) => {
  const c = CONF[status] || CONF.UNKNOWN;
  const Icon = c.icon;
  return (
    <span data-testid={testId || `confidence-${status}`} className={`inline-flex items-center gap-1 rounded-full border px-2 py-0.5 text-xs font-semibold ${c.cls}`}>
      <Icon className="h-3 w-3" /> {c.label}
    </span>
  );
};

const URG = {
  RED: "bg-red-600 text-white", ORANGE: "bg-orange-600 text-white", YELLOW: "bg-amber-500 text-slate-900", GREEN: "bg-green-800 text-white",
};

export const UrgencyBadge = ({ color, label, testId = "urgency-badge" }) => (
  <span data-testid={testId} className={`inline-flex items-center gap-1.5 rounded-full px-3 py-1 text-xs font-bold uppercase tracking-wider ${URG[color] || URG.GREEN} ${color === "RED" ? "pulse-ring" : ""}`}>
    {color} — {label}
  </span>
);

export const Logo = ({ dark, className = "h-11" }) => (
  <div className={`inline-flex items-center ${dark ? "rounded-lg bg-white px-2 py-1" : ""}`} data-testid="askjoe-logo">
    <img src="/brand/logo.webp" alt="AskJoe-AI.com — Real Answers. Real Options. A Brighter Tomorrow." className={`${className} w-auto`} />
  </div>
);
